import { defineComponent, onMounted, defineAsyncComponent  } from 'vue';
import ActAccessModal from '@/presentation/components/act-access-modal/act-access-modal.vue';
import SuccessMessage from '@/presentation/components/success-message/success-message.vue';
import ActAccessOverviewCode from '@/presentation/pages/act-access-overview/act-access-overview.code';
import tableComponentLoader from '@/presenters/table-component-loader';

export default defineComponent({
	components: {
		ActAccessTable: defineAsyncComponent(tableComponentLoader.loadActAccessTable.bind(tableComponentLoader)),
		ActAccessModal,
		SuccessMessage
	},
	setup: () => {
		const code = new ActAccessOverviewCode();

		onMounted(code.mounted.bind(code));

		return {
			isActAccessModalActive: code.isActAccessModalActive,
			navigateToUserActionsPage: code.navigateToUserActionsPage.bind(code)
		};
	}
});
